// @flow
import mediatorChannels from "@tvg/mediator";
import { get } from "lodash";
import pushToDataLayer from "../gtmUtils";

type PreferencesGTMTypeEvents = "UNSUBSCRIBE_BUTTON_CLICK";

type Payload = {
  gaEventLabel: string
};

type PreferencesGTMT = {
  type: PreferencesGTMTypeEvents,
  payload: Payload
};

export default () => {
  mediatorChannels.base.subscribe(
    "UNSUBSCRIBE_BUTTON_CLICK",
    (data: PreferencesGTMT) => {
      pushToDataLayer({
        event: "preferences",
        gaEventAction: "CTA Clicked",
        gaEventCategory: "Preferences",
        gaEventLabel: get(data, "payload.gaEventLabel", ""),
        module: "Email Unsubscribe"
      });
    }
  );

  mediatorChannels.base.subscribe("UNSUBSCRIBE_SUCCESSFULLY", () => {
    pushToDataLayer({
      event: "preferences",
      gaEventAction: "Unsubscribe Success",
      gaEventCategory: "Preferences",
      gaEventLabel: undefined,
      module: "Email Unsubscribe"
    });
  });

  mediatorChannels.base.subscribe("UNSUBSCRIBE_FAIL", () => {
    pushToDataLayer({
      event: "preferences",
      gaEventAction: "Unsubscribe Fail",
      gaEventCategory: "Preferences",
      gaEventLabel: "Missing required url parameter",
      module: "Email Unsubscribe"
    });
  });

  mediatorChannels.base.subscribe(
    "SUBSCRIBE_BUTTON_CLICK",
    (data: { payload: Payload }) =>
      pushToDataLayer({
        event: "preferences",
        gaEventAction: "CTA Clicked",
        gaEventCategory: "Preferences",
        gaEventLabel: get(data, "payload.gaEventLabel", ""),
        module: "Communication Preferences"
      })
  );

  mediatorChannels.base.subscribe("SUBSCRIBE_SUCCESSFULLY", () => {
    pushToDataLayer({
      event: "preferences",
      gaEventAction: "Subscribe Success",
      gaEventCategory: "Preferences",
      gaEventLabel: undefined,
      module: "Communication Preferences"
    });
  });

  mediatorChannels.base.subscribe(
    "SUBSCRIBE_FAIL",
    (data: { payload: { gaEventLabel: string } }) => {
      pushToDataLayer({
        event: "preferences",
        gaEventAction: "Subscribe Fail",
        gaEventCategory: "Preferences",
        gaEventLabel: get(data, "payload.gaEventLabel", ""),
        module: "Communication Preferences"
      });
    }
  );
};
